var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "list-group-item font-weight-bold ",
      attrs: { role: "button" },
      on: {
        click: function($event) {
          return _vm.$emit("click", [_vm.text, _vm.itemKey, _vm.icon])
        }
      }
    },
    [
      _c("i", { staticClass: "fas", class: _vm.textIcon }),
      _vm._v(_vm._s(_vm.text))
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }